import {
  decodeBytesWithCharset,
  encodeBytesWithCharset
} from "./chunk-2KA626OL.js";

// src/base58.ts
var charset = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var encode = (bytes) => encodeBytesWithCharset(bytes, charset);
var decode = (input) => decodeBytesWithCharset(input, charset);

export {
  encode,
  decode
};
